import {
  catalogScopeKey,
  catalogScopeMatches,
  type CatalogScope,
} from './catalogScope'

export async function retrieveCatalogRaw (input: {
  runScope: CatalogScope | undefined
  liveScope: () => CatalogScope | undefined
  get: (key: string) => Promise<string | undefined>
}): Promise<string | undefined> {
  if (!catalogScopeMatches(input.runScope, input.liveScope()) || !input.runScope) {
    return undefined
  }

  const raw = await input.get(catalogScopeKey(input.runScope))

  if (!catalogScopeMatches(input.runScope, input.liveScope())) {
    return undefined
  }

  return raw
}

export async function persistCatalogRecords (input: {
  runScope: CatalogScope | undefined
  liveScope: () => CatalogScope | undefined
  records: unknown
  set: (key: string, value: string, stillCurrent: () => boolean) => Promise<void>
}): Promise<void> {
  if (!catalogScopeMatches(input.runScope, input.liveScope()) || !input.runScope) {
    return
  }

  const key = catalogScopeKey(input.runScope)
  const value = JSON.stringify(input.records)
  const stillCurrent = () => catalogScopeMatches(input.runScope, input.liveScope())

  await input.set(key, value, stillCurrent)
}
